import { DEAL_ACTIVITY } from './dealActivity';
import { DEAL_CONTACTS } from './dealContacts';
import { DEAL_ACTIVITIES } from './dealActivities';
import { DEAL_ACTIVITY_COUNT } from './dealActivityCount';
import { CREATE_DEAL_ACTIVITIES } from './createDealActivities';
import { UPDATE_DEAL_ACTIVITIES } from './updateDealActivities';
import { DELETE_DEAL_ACTIVITIES } from './deleteDealActivities';

export * from './useDealActivityMutations';
export * from './useFetchActivityList';

export const dealActivityApi = {
  dealContacts: DEAL_CONTACTS,
  dealActivity: DEAL_ACTIVITY,
  dealActivities: DEAL_ACTIVITIES,
  dealActivityCount: DEAL_ACTIVITY_COUNT,

  create: CREATE_DEAL_ACTIVITIES,
  update: UPDATE_DEAL_ACTIVITIES,
  delete: DELETE_DEAL_ACTIVITIES,
};
